var React = require('react');

function Share (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"sharetoafriend"),React.createElement("path",{"d":"M28.9,38a.75.75,0,0,0,.8-.1l12-9.9a.71.71,0,0,0,.3-.6.86.86,0,0,0-.3-.6l-12-9.9a.75.75,0,0,0-.8-.1.67.67,0,0,0-.4.7v5.2c-13.8.5-13.7,10.9-13.7,16v.6a.73.73,0,0,0,.6.7h.2a.75.75,0,0,0,.7-.4c4.1-7.2,7.4-7.5,12.3-7.5v5.2C28.4,37.6,28.6,37.8,28.9,38Z","transform":"translate(-14.8 -16.73)","style":{"fill":"#238c84"},"key":1})]);
}

Share.defaultProps = {"id":"Calque_1","data-name":"Calque 1","viewBox":"0 0 27.2 23.27"};

module.exports = Share;

Share.default = Share;
